import { AxiosResponse } from 'axios';
import { axiosInstance } from 'shared/config/axios';
import {
	ExportErrorsReportReq,
	ExportErrorsReq,
	LogsListRes,
	LogsPaginationReq,
} from 'entities/Logs/logsTypes';

export const getUserLogs = (
	userId: string,
	params?: LogsPaginationReq,
): Promise<AxiosResponse<LogsListRes>> => {
	return axiosInstance.get(`/logs/${userId}`, { params });
};

export const getExportErrors = (params: ExportErrorsReq): Promise<AxiosResponse<LogsListRes>> => {
	return axiosInstance.get('/logs/export-errors', { params });
};

export const downloadExportErrorsReport = (params: ExportErrorsReportReq): Promise<AxiosResponse<Blob>> => {
	return axiosInstance.get('/logs/export-errors/download', { params, responseType: 'blob' });
};
